import DnWidgetBase from './DnWidgetBase.vue'

export default DnWidgetBase
